import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Alert } from 'react-bootstrap';

import IntlDate from 'components/layout/IntlDate';

import RichEditorContent from 'components/RichEditorContent';
import DataId from 'components/DataId';

import HandoverDetails from 'components/modals/HandoverDetails';

import AbstractTimelineEvent from './AbstractTimelineEvent';

class TimelineHandoverCreated extends AbstractTimelineEvent {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
    };
  }

  showDetails = () => {
    this.setState({ showDetails: true });
  };

  closeDetails = () => {
    this.setState({ showDetails: false });
  };

  getHandoverDetails = () => {
    const { handoverDetails } = this.props;
    const handoverId = this.getParam('handoverId');
    return handoverDetails[handoverId] ? handoverDetails[handoverId] : { pending: true };
  };

  render() {
    const {
      intl: { messages },
      event,
    } = this.props;
    const { showDetails } = this.state;

    const handoverDetails = this.getHandoverDetails();
    const damagesCount = this.getDynParam('damagesCount', 0);

    return (
      <div className="card-block">
        {!!damagesCount && (
          <Alert bsStyle="danger">
            <i className="fal fa-claw-marks" /> {messages.damages_present}
          </Alert>
        )}

        <RichEditorContent content={'<div>' + event.getText() + '</div>'} />

        {event && event.getDynParams() && event.getDynParams().length ? (
          <div className="p-t-10">
            <DataId
              dataIdName="handover"
              dataIdId={this.getParam('handoverId')}
              url={'/api/handovers/' + this.getParam('handoverId') + '.json'}
            />

            {handoverDetails.pending ? (
              <div>
                <i className="fas fa-circle-notch fa-spin" />
              </div>
            ) : (
              <div>
                <p>{messages.infos}</p>
                <dl>
                  <dt className="m-t-5">{messages.difficulties}</dt>
                  <dd>{handoverDetails.data.difficulties ? messages[handoverDetails.data.difficulties] : '-'}</dd>

                  <dt className="m-t-5">{messages.mileage}</dt>
                  <dd>
                    {handoverDetails.data.mileage} {messages.mileage_unit}
                  </dd>

                  <dt className="m-t-5">{messages.fuel_level}</dt>
                  <dd>{handoverDetails.data.fuel_level}%</dd>

                  <dt className="m-t-5">{messages.damages}</dt>
                  <dd>
                    {damagesCount ? (
                      <span>
                        <i className="fal fa-claw-marks text-danger" /> {messages.yes} ({damagesCount})
                      </span>
                    ) : (
                      <span>
                        <i className="fal fa-check text-success" /> {messages.no}
                      </span>
                    )}
                  </dd>

                  <dt className="m-t-5">{messages.date_created}</dt>
                  <dd>
                    <IntlDate date={handoverDetails.data.cdate} />
                  </dd>
                </dl>

                <div className="m-t-10">
                  <Button onClick={this.showDetails}>
                    <i className="fa fa-eye" /> {messages.view}
                  </Button>
                </div>

                <HandoverDetails show={showDetails} close={this.closeDetails} handover={handoverDetails} />
              </div>
            )}
          </div>
        ) : (
          <Alert>{messages.no_details_available}</Alert>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    handoverDetails: state.dataId.handover,
  };
};

export default injectIntl(connect(mapStateToProps)(TimelineHandoverCreated));
